export default "__VITE_ASSET__IeKbjyeo__"